import { DineoutPaymentExternalRoutes } from "@swiggy-private/dineout-cart-client";

export const ExternalRoutes = [...DineoutPaymentExternalRoutes];
